import { PermissionDomains } from '../../components/v2BaseComponents/Permissions/types';
import { MedicalDataTypes } from '../../primary-record-types';

export const categoryToDomain = (category: MedicalDataTypes.PrimaryRecordResourceCategory) => {
    const map: Record<MedicalDataTypes.PrimaryRecordResourceCategory, PermissionDomains> = {
        condition: 'conditions',
        medication: 'medications',
        allergy: 'allergies',
        visit: 'visits',
        imaging: 'imaging',
        vaccination: 'vaccinations',
        procedure: 'procedures',
        lab: 'labs',
    };

    return map[category];
};

export const domainToCategory = (domain: PermissionDomains) => {
    const map: Partial<Record<PermissionDomains, MedicalDataTypes.PrimaryRecordResourceCategory>> = {
        conditions: 'condition',
        medications: 'medication',
        allergies: 'allergy',
        visits: 'visit',
        imaging: 'imaging',
        vaccinations: 'vaccination',
        procedures: 'procedure',
        labs: 'lab',
    };

    return map[domain];
};
